import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C329F2CA-AC52-45CD-87D7-253AB115D47F
 * name window-minimize
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-minimize.svg
 * tags
 */
export const WindowMinimizeIcon = createSvgIcon(<><path d="M20,14H4V10H20" /></>, 'WindowMinimizeIcon');
export default WindowMinimizeIcon